import { type AutocompleteProps } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { BaseAutocomplete } from '@/global/components/Autocompletes/BaseAutocomplete';
import { apiGetRegionList } from '@/modules/regions/services/regions.service';
import type { RegionDto } from '@/global/api/gen/ts/RegionDto';
import { useTranslation } from 'react-i18next';

type Props = {
    onChange: (value: RegionDto | null) => void;
    message?: string;
    label?: string;
    placeholder?: string;
    defaultId?: number | null;
} & Omit<AutocompleteProps<RegionDto, false, boolean, false>, 'options' | 'onChange' | 'renderInput'>

export function RegionsAutocomplete({onChange, defaultId, message, placeholder, ...props}: Props) {
    const {i18n} = useTranslation();
    const defaultValue = useRef<RegionDto>();
    const {data: regions, isLoading} = apiGetRegionList({
        limit: 100,
        offset:0,
    });

    useEffect(() => {
        if (regions) {
            defaultValue.current = regions.items.find((region) => region.id === defaultId);
        }
    }, [regions]);

    return (
        <BaseAutocomplete
            onChange={onChange}
            options={regions?.items ?? []}
            defaultValue={defaultValue.current}
            getOptionLabel={(option) => i18n.language === 'kz' ? option.name_kz : option.name_ru}
            isLoading={isLoading}
            {...props}
        />
    );
}